import { Component, OnInit, Input, Renderer2, ViewChild, OnDestroy, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '@models/User';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@services/auth.service';
import { AppService } from '@services/support/app.service';
import { UtilityService } from '@services/remote/utility.service';
import { LoaderService } from '@services/support/loader.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { AlertModalComponent } from '../../modals/alert-modal/alert-modal.component';
import { MultilanguageService } from '@services/support/multilanguage.service';
import { environment } from '../../../../environments/environment';
import { DetailPageService } from '@services/detail-page.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SidebarComponent implements OnInit, OnDestroy {
  @Input() isAdmin
  @Input() editorAccess
  @Input() isEditorMode

  userSub: Subscription;
  user: User
  version
  currentLang
  allLangs = []
  showLangs: boolean = false
  addOns: any = null

  @ViewChild('optionsDropdown') optionsDropdown?: any;
  @ViewChild('menu') menu: any;

  subscriptions: Subscription[] = []

  noRemoteLicense = true
  noWorkflowLicense = true
  isMaster = false

  constructor(private translateService: TranslateService,
    private modalService: BsModalService,
    private loaderService: LoaderService,
    private authService: AuthService,
    private renderer: Renderer2,
    private appService: AppService,
    private multilanguageService:MultilanguageService,
    private router: Router,
    private detailPageService: DetailPageService,
    private utilityService: UtilityService
  ) {
    this.renderer.listen('window', 'click', (e: Event) => {
      if (e.target !== this.optionsDropdown ?.nativeElement && e.target !== this.menu ?.nativeElement) {
        
      }
    })
  }
     
  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe())
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.authService.user.subscribe((user) => {
        this.user = user;
      })
    )

    Promise.all([
      this.authService.getAccountData(),
      this.utilityService.getServerTimeOffset()
    ]).then(([account, offset]) => {
      const webhooksAvailable = account.data.accountData.add_ons?.workflowwebhooks
      const hasVideoFlow = account.data.accountData.add_ons?.videoflow
      const hasWorkorder = account.data.accountData.add_ons?.workorder
      const showNova = account.data.accountData.add_ons?.aiassistant
      const hasTicket = account.data.accountData.add_ons?.ticket

      this.addOns = {
        webhooksAvailable : webhooksAvailable,
        hasVideoFlow : hasVideoFlow,
        hasWorkorder: hasWorkorder,
        showNova: showNova,
        hasTicket: hasTicket
      }

      // Check if this is a master (parent) account
      this.isMaster = account.data.accountData.organization?.is_master === true

      const currentTime = (new Date()).getTime()

      const license = account.data.accountData.license
      const now = currentTime + offset
      const twelveHoursInMs = 1000*60*60*12

      this.noRemoteLicense = !license.remote_account || (license.remote_start - twelveHoursInMs > now) || (license.remote_end + twelveHoursInMs < now)
      this.noWorkflowLicense = !license.workflow_account || (license.workflow_start - twelveHoursInMs > now) || (license.workflow_end + twelveHoursInMs < now)
    });

    this.currentLang = this.multilanguageService.currentLang;
    this.allLangs = this.multilanguageService.allLangs;
  
    this.subscriptions.push(
      this.multilanguageService.onLangChange.subscribe(change => {
        this.currentLang = change.lang;
      })
    );
  
    this.version = environment.version;
  }

  onSidebarLinkClicked() {
    this.detailPageService.removeComponent()
  }

  dropdownAction(workflow, event: Event) {
    event.stopPropagation()
    workflow['show'] = !workflow['show']
  }

  onLogout() {
    const initialState= {
      textMessage : this.translateService.instant('MAIN.NAVBAR.LOGOUT.TEXT-MESSAGE.MESSAGE'),
      confirmButtonText : this.translateService.instant('MAIN.NAVBAR.LOGOUT.TEXT-MESSAGE.CONFIRM'),
      headerTitle: this.translateService.instant('MAIN.CONTENT.WORKFLOW.HEADER-TITLES.LOGOUT')
    };
    let alertmodalRef = this.modalService.show(AlertModalComponent, {
      initialState,
      backdrop: 'static',
      class: 'modal-dialog-centered',
      animated: false
    })
    alertmodalRef.content.onClose.subscribe((res) => {
      if (res) {
        this.loaderService.show();
        this.authService.logout().finally(() => {
          this.loaderService.hide();
        });
      }else{
        alertmodalRef.hide()
      }
    });
  }

  switchMode(mode) {
    this.appService.isEditorModeSource.next(mode)
    this.router.navigate(['/']);
  }

  onLanguageSelected(lang: any) {
    this.multilanguageService.setCurrentLanguage(lang.code);
  }
}
